import styled from 'styled-components'
import { IconV2 } from 'ui/components'

export const Section = styled.div`
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 48px;
  &:first-child {
    padding-top: 32px;
  }
  display: flex;
  flex-direction: column;
  justify-items: stretch;
  gap: 20px;
`

export const TableHeader = styled.div`
  min-height: 70px;
  background: var(--theme-colors-global-general-main);
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 20px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-bottom: 1px solid var(--theme-colors-global-grey-grey500);
`

export const TableInfo = styled.div``

export const TableKey = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  font: var(--theme-typography-h4-regular);
`

export const TableKeyInfo = styled.div`
  margin-left: auto;
  margin-top: 6px;
  display: flex;
  gap: 8px;
  align-items: center;
`

export const ConnectionInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font: var(--theme-typography-bodyM-regular);
  margin-right: 28px;
`

export const CurrentLicenseIcon = styled(IconV2)`
  color: var(--theme-colors-theme-brand-primary);
`

export const KeyAddedInfoIcon = styled(IconV2)`
  color: var(--theme-colors-global-grey-grey500);
`
